import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import MinimalLayout from 'layout/MinimalLayout';

// lazy-loaded pages
const SuperAdminLogin = Loadable(lazy(() => import('pages/authentication/SuperAdminLogin')));
const SuperAdminDashboard = Loadable(lazy(() => import('pages/superadmin/SuperAdminDashboard')));
const SuperAdminPlans = Loadable(lazy(() => import('pages/superadmin/SuperAdminPlans')));
const SuperAdminOrganizations = Loadable(lazy(() => import('pages/superadmin/SuperAdminOrganizations')));
const SuperAdminUsers = Loadable(lazy(() => import('pages/superadmin/SuperAdminUsers')));
const SuperAdminSettings = Loadable(lazy(() => import('pages/superadmin/SuperAdminSettings')));
const SuperAdminGeo = Loadable(lazy(() => import('pages/superadmin/SuperAdminGeo')));
const SuperAdminVoters = Loadable(lazy(() => import('pages/superadmin/SuperAdminVoters')));
const SuperAdminAgentTiers = Loadable(lazy(() => import('pages/superadmin/SuperAdminAgentTiers')));
const SuperAdminCommConfig = Loadable(lazy(() => import('pages/superadmin/SuperAdminCommConfig')));
const SuperAdminTally = Loadable(lazy(() => import('pages/superadmin/SuperAdminTally')));
const SuperAdminCredits = Loadable(lazy(() => import('pages/superadmin/SuperAdminCredits')));
const SuperAdminPayments = Loadable(lazy(() => import('pages/superadmin/SuperAdminPayments')));

// ==============================|| SUPER ADMIN ROUTES ||============================== //

const SuperAdminRoutes = {
  path: '/admin',
  children: [
    {
      path: 'login',
      element: <MinimalLayout />,
      children: [{ index: true, element: <Navigate to="/admin/dashboard" replace /> }]
    },
    {
      path: '',
      element: <MainLayout />,
      children: [
        { path: 'dashboard', element: <SuperAdminDashboard /> },
        { path: 'plans', element: <SuperAdminPlans /> },
        { path: 'credits', element: <SuperAdminCredits /> },
        { path: 'payments', element: <SuperAdminPayments /> },
        { path: 'organizations', element: <SuperAdminOrganizations /> },
        { path: 'users', element: <SuperAdminUsers /> },
        { path: 'settings', element: <SuperAdminSettings /> },
        { path: 'geo/counties', element: <SuperAdminGeo /> },
        { path: 'geo/constituencies', element: <SuperAdminGeo /> },
        { path: 'geo/wards', element: <SuperAdminGeo /> },
        { path: 'geo/polling-stations', element: <SuperAdminGeo /> },
        { path: 'voters', element: <SuperAdminVoters /> },
        { path: 'agent-tiers', element: <SuperAdminAgentTiers /> },
        { path: 'comm-config', element: <SuperAdminCommConfig /> },
        { path: 'tally', element: <SuperAdminTally /> }
      ]
    }
  ]
};

export default SuperAdminRoutes;
